"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("./index.css");

var _numberData = _interopRequireDefault(require("../number-data"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _htmlShortNumberFormatter = _interopRequireDefault(require("../label-formatters/html-short-number-formatter"));

var _responsiveStyleManager = require("../responsive-style-manager");

var _mwNumberOptions = _interopRequireDefault(require("./mw-number-options"));

/**
 * A class for rendering a number
 * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
 */
var MwNumber =
/*#__PURE__*/
function () {
  function MwNumber(renderTarget) {
    (0, _classCallCheck2.default)(this, MwNumber);
    var renderTargetElement;

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    if (typeof renderTarget === 'string') {
      renderTargetElement = document.getElementById(renderTarget);

      if (!renderTargetElement) {
        throw new TypeError("renderTarget string is invalid. Provided value: ".concat(renderTarget));
      }
    } else if (typeof renderTarget.innerHTML !== 'string') {
      throw new TypeError("renderTarget.innerHTML string is invalid. Provided value: ".concat(renderTarget));
    } else {
      renderTargetElement = renderTarget;
    }

    this.__data = null;
    this.__options = new _mwNumberOptions.default({});
    this.__renderTarget = renderTargetElement;
    this.__responsiveStyleManager = new _responsiveStyleManager.ResponsiveStyleManager();
  }
  /**
   * Set the visualization data to be rendered
   * @param {NumberData} numberData - The data to be rendered to the visualization
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwNumber, [{
    key: "setData",
    value: function setData(numberData) {
      this.__data = (0, _coerce.default)(numberData, _numberData.default, "data should be shaped like a NumberData class. Provided value: ".concat(JSON.stringify(numberData)));
    }
    /**
     * Set the visualization options for the visualiztion
     * @param {MwNumberOptions} options - The options for the visualization
     * @returns {undefined}
     */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.__options = (0, _coerce.default)(options, _mwNumberOptions.default, "options should be shaped like a MwNumberOptions. Provided value: ".concat(JSON.stringify(options)));
    }
    /**
     * Clean up when the visualization is no longer needed.
     * This is required to lessen performance load when the element is removed from the DOM.
     * @returns {undefined}
     */

  }, {
    key: "remove",
    value: function remove() {
      if (this.__registrationId) {
        this.__responsiveStyleManager.unregister(this.__registrationId);

        delete this.__registrationId;
      }
    }
    /**
     * Render the number to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      var numberUnits = this.__options.unit;
      var numberUnitsClass = 'mw-number__units';
      var numberPrefix = '';

      if (this.__data === null) {
        throw new TypeError("Data was not set before render was called. Provided value: ".concat(JSON.stringify(this.__data)));
      }

      if (!numberUnits) {
        numberUnitsClass += ' mw-number__units_no_unit_of_measure';
      }

      if (Math.round(this.__data.number) < 0) {
        numberPrefix = '-';
      }

      this.remove();
      this.__registrationId = this.__responsiveStyleManager.register({
        element: this.__renderTarget,
        breakpointStyles: [{
          className: 'mwv-medium-breakpoint',
          minWidth: 230
        }]
      });
      this.__renderTarget.innerHTML = "\n            <div class=\"mw-number__container\">\n                <div class=\"mw-number__container--child\">\n                    <div class=\"mw-number__number\">".concat(numberPrefix).concat((0, _htmlShortNumberFormatter.default)(this.__data.number), "</div>\n                    <div class=\"").concat(numberUnitsClass, "\">").concat(numberUnits, "</div>\n                </div>\n            </div>\n        ");
    }
  }]);
  return MwNumber;
}();

exports.default = MwNumber;